import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import {
  BadgeGreen,
  BadgeBlue,
  BadgeRed,
  BadgeOrange,
  BadgePurple,
  BadgeAmber,
  BadgeZinc,
} from "../badge/Badge";

export type OrderStage =
  | "Accepted"
  | "Requested"
  | "Confirmed"
  | "Dispatched"
  | "Delivered"
  | "Cancelled"
  | "Voided";

export const generateOrderNumber = (o: OrderGetResponseType): string => {
  if (!o) return "";

  if (o.OrderItems) {
    return `Order #${o.customInvoiceNumber ?? o.id}`;
  }

  return `Order #${o.id}`;
};

export const getBackgroundColorFromOrderStage = (stage: OrderStage): string => {
  switch (stage) {
    case "Requested":
      return "bg-amber-500";
    case "Accepted":
      return "bg-amber-500";
    case "Confirmed":
      return "bg-emerald-500";
    case "Dispatched":
      return "bg-violet-500";
    case "Delivered":
      return "bg-blue-500";
    case "Cancelled":
      return "bg-red-500";
    case "Voided":
      return "bg-zinc-500";
  }
};

export const getHoverColorFromOrderStage = (stage: OrderStage): string => {
  switch (stage) {
    case "Requested":
      return "hover:bg-amber-600";
    case "Accepted":
      return "hover:bg-amber-600";
    case "Confirmed":
      return "hover:bg-emerald-600";
    case "Dispatched":
      return "hover:bg-violet-600";
    case "Delivered":
      return "hover:bg-blue-600";
    case "Cancelled":
      return "hover:bg-red-600";
    case "Voided":
      return "hover:bg-zinc-600";
  }
};

export const getTextColorFromOrderStage = (stage: OrderStage): string => {
  switch (stage) {
    case "Requested":
      return "text-amber-500";
    case "Accepted":
      return "text-amber-500";
    case "Confirmed":
      return "text-emerald-500";
    case "Dispatched":
      return "text-violet-500";
    case "Delivered":
      return "text-blue-500";
    case "Cancelled":
      return "text-red-500";
    case "Voided":
      return "text-zinc-500";
  }
};

export const getOrderStageBadge = (stage: OrderStage) => {
  switch (stage) {
    case "Requested":
      return <BadgeAmber>Requested</BadgeAmber>;
    case "Accepted":
      return <BadgeOrange>Accepted</BadgeOrange>;
    case "Confirmed":
      return <BadgeGreen>Finalised</BadgeGreen>;
    case "Dispatched":
      return <BadgePurple>Dispatched</BadgePurple>;
    case "Delivered":
      return <BadgeBlue>Delivered</BadgeBlue>;
    case "Cancelled":
      return <BadgeRed>Cancelled</BadgeRed>;
    case "Voided":
      return <BadgeZinc>Voided</BadgeZinc>;
  }
};

export const getOrderStage = (
  order?: Pick<
    OrderGetResponseType,
    | "cancelledAt"
    | "deliveredAt"
    | "dispatchedAt"
    | "confirmedAt"
    | "acceptedAt"
    | "voidedAt"
  >,
): OrderStage => {
  if (order?.voidedAt) return "Voided";
  if (order?.cancelledAt) return "Cancelled";
  if (order?.deliveredAt) return "Delivered";
  if (order?.dispatchedAt) return "Dispatched";
  if (order?.confirmedAt) return "Confirmed";
  if (order?.acceptedAt) return "Accepted";
  // TODO: Quoted
  return "Requested";
};
